import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImage from "../../Assets/myimg.JPEG";
import CodingWebsiteStack from '../About/CodingWebsiteStack';
import Achievements from "../About/Achievements";
import Projects from "../Projects/Projects";
import CommunityWork from "../Community/CommunityWork";
import Experience from "../About/Experience";
// import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <div class='rectangle'>
            <Col md={7} className="home-header">
              <h3 className="heading">
                Hi There! <span className="wave" role="img" aria-labelledby="wave">👋🏻</span>
              </h3>

              <h3 className="heading-name">
                I'M
                <strong className="main-name"> Deep Patel</strong>
              </h3>


              {/* <p className="home-bio">Pre-final year Information Technology graduate student at Dharmsinh Desai University. </p> */}
            
              <div style={{ padding: 5, textAlign: "left" }}>
                {/* <Type /> */}
                <p className="home-bio">I am Associate Software Engineer at HhaeXchange. I am a passionate learner and have tried hands-on technologies like Spring Boot, Flutter and ReactJs. I share my knowledge on Medium and YouTube.</p>
              </div>
            </Col>
            </div>

            <Col md={5} >
              <img style={{transform:"scale(1.4,1.4)", position:"relative", top: "-50px"}} src={myImage} alt="home pic" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="about-section">
        <Container>
        {/* <div style={{ marginLeft: 20, paddingBottom: "50px" }}><SelectedProjects /></div> */}
        <div style={{ marginLeft: 20, paddingBottom: "50px" }}><Experience /></div>
        <div style={{ marginLeft: 20, paddingBottom: "50px" }}><Projects /></div>
        <div style={{ marginLeft: 20, paddingBottom: "50px" }}><Achievements /></div>
        <div style={{ marginLeft: 20, paddingBottom: "50px" }}><CodingWebsiteStack /></div>
        <div style={{ marginLeft: 20, paddingBottom: "50px" }}><CommunityWork /></div>
        </Container>
      </Container>
    </section>
  );
}

export default Home;
